<template>
  <section space-y-4>
    <h2 text-2xl font-semibold text-stone-500>{{ heading }}</h2>
    <ul v-if="places.length" grid sm:grid-cols-2 gap-2>
      <li v-for="place in places" :key="place.url">
        <NuxtLink
          :to="place.url"
          block
          h-full
          rounded
          bg-stone-50
          p-3
          border-stone-100
          border-3
          class="hover:(border-stone-200 bg-stone-100)"
        >
          <div text-lg font-semibold text-stone-600 lh-snug>{{ place.name }}</div>
          <div v-if="details(place)" font-mono text-sm text-stone-500>{{ details(place) }}</div>
        </NuxtLink>
      </li>
    </ul>
    <ul v-if="county || state" space-y-2 font-bold>
      <li>
        <NuxtLink v-if="county" color="light-stone" :to="county.url"> {{ county.fullName }} snow totals </NuxtLink>
      </li>
      <li>
        <NuxtLink v-if="county" color="light-stone" :to="county.mapUrl"> {{ county.fullName }} map </NuxtLink>
      </li>
      <li>
        <NuxtLink v-if="state" color="light-stone" :to="state.atlasUrl"> {{ state.name }} snow totals </NuxtLink>
      </li>
    </ul>
  </section>
</template>
<script setup>
defineProps({
  heading: { type: String, required: true },
  // [{ name, url, miles?, direction?, annual? }]
  places: { type: Array, default: () => [] },
  county: { type: Object, default: null },
  state: { type: Object, default: null },
});

// e.g. "5 mi NW • 95 in of snow a year"
function details(place) {
  const parts = [];
  if (isNumber(place.miles)) {
    parts.push(`${place.miles} mi${place.direction ? ` ${place.direction}` : ""}`);
  }
  if (isNumber(place.annual)) {
    parts.push(`${numberFormatted(place.annual)} in avg`);
  }
  return parts.join(" • ");
}
</script>
